import api from '../api/client';

const despesasService = {
  listar: (organizadorId, loteId) =>
    api.get(`/organizadores/${organizadorId}/lotes/${loteId}/despesas`).then(r => r.data),

  criar: (organizadorId, loteId, data) =>
    api.post(`/organizadores/${organizadorId}/lotes/${loteId}/despesas`, data).then(r => r.data),

  atualizar: (organizadorId, loteId, despesaId, data) =>
    api.put(`/organizadores/${organizadorId}/lotes/${loteId}/despesas/${despesaId}`, data).then(r => r.data),

  excluir: (organizadorId, loteId, despesaId) =>
    api.delete(`/organizadores/${organizadorId}/lotes/${loteId}/despesas/${despesaId}`),

  /** Adiciona despesa em batch (lotes faturados, fluxo separada) */
  adicionarSeparadaBatch: (organizadorId, data) =>
    api.post(`/organizadores/${organizadorId}/lotes/despesa-separada-batch`, data).then(r => r.data),
};

export default despesasService;
